import Vue from 'vue'
import Router from 'vue-router'
import {startrouter,routes} from "@/router";
Vue.use(Router)

import ReconciliationDetail from '@/Special/ZL/view/ReconciliationDetail'
import DeliverSearchDetail from '@/Special/ZL/view/DeliverSearchDetail'

var routeArray = [
  {
    name:"ReconciliationDetail",
    component:ReconciliationDetail
  },
  {
    name:'DeliverSearchDetail',
    component:DeliverSearchDetail
  }
]
var router = startrouter(routes,routeArray);

export {router}